import { createSelector } from '@reduxjs/toolkit';

const baseSelector = (state) => state.coursePauseRequest;

export const coursePauseModalStageSelector = createSelector(
  (state) => baseSelector(state).coursePauseModalStage,
  (coursePauseModalStage) => coursePauseModalStage
);

export const selectedRequestSelector = createSelector(
  (state) => baseSelector(state).selectedRequest,
  (selectedRequest) => selectedRequest
);

export const selectedSbatLectureSelector = createSelector(
  (state) => baseSelector(state).selectedSbatLecture,
  (selectedSbatLecture) => selectedSbatLecture
);

export const selectedSuperBatchSelector = createSelector(
  (state) => baseSelector(state).selectedSuperBatch,
  (selectedSuperBatch) => selectedSuperBatch
);

export const sortRequestFieldSelector = createSelector(
  (state) => baseSelector(state).sortRequestField,
  (sortRequestField) => sortRequestField
);

export const sortRequestTypeSelector = createSelector(
  (state) => baseSelector(state).sortRequestType,
  (sortRequestType) => sortRequestType
);

export const currentPageSelector = createSelector(
  (state) => baseSelector(state).currentPage,
  (currentPage) => currentPage
);

export const cancelRequestModalStageSelector = createSelector(
  (state) => baseSelector(state).cancelPauseRequestModalStage,
  (cancelPauseRequestModalStage) => cancelPauseRequestModalStage
);

export const editPauseDurationModalStageSelector = createSelector(
  (state) => baseSelector(state).editPauseDurationModalStage,
  (editPauseDurationModalStage) => editPauseDurationModalStage
);

export const viewLectureModalStateSelector = createSelector(
  (state) => baseSelector(state).viewLectureModalState,
  (viewLectureModalState) => viewLectureModalState
);

export const updateDurationTypeSelector = createSelector(
  (state) => baseSelector(state).updateDurationType,
  (updateDurationType) => updateDurationType
);

export const updateDurationSourceSelector = createSelector(
  (state) => baseSelector(state).updateDurationSource,
  (updateDurationSource) => updateDurationSource
);

export const updateDurationMonthsBySelector = createSelector(
  (state) => baseSelector(state).updateDurationMonthsBy,
  (updateDurationMonthsBy) => updateDurationMonthsBy
);

export const coursePauseRescheduleModalStageSelector = createSelector(
  (state) => baseSelector(state).coursePauseRescheduleModalStage,
  (coursePauseRescheduleModalStage) => coursePauseRescheduleModalStage
);

export const coursePauseRequestApproveModalStageSelector = createSelector(
  (state) => baseSelector(state).coursePauseRequestApproveModalStage,
  (coursePauseRequestApproveModalStage) => coursePauseRequestApproveModalStage
);

export const coursePauseRequestedRequestUpdateModalSelector = createSelector(
  (state) => baseSelector(state),
  ({
    coursePauseRequestedRequestUpdateModalStage,
    coursePauseRequestedDuration,
    coursePauseRequestedStreakEnabled,
  }) => ({
    modalStage: coursePauseRequestedRequestUpdateModalStage,
    coursePauseRequestedDuration,
    coursePauseRequestedStreakEnabled,
  })
);
